import React, { useEffect, useState } from "react";
import StudentsNavbar from "../Components/Navbars/StudentsNavbar";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Pagination, Tabs, Table, Button, Select, TabsProps, PaginationProps } from "antd";
import usePortalService from "../services/PortalService";
import { ReactionStatus } from "../Enums/ReactionStatus";
import { Form } from "react-bootstrap";
import { ColumnsType } from "antd/es/table";
import { Reaction } from "../types";
import { LoaderWithTimer } from "../Components/LoaderWithTimer";

const Container = styled.div`
  width: 100%;
  padding-left: 6%;
  padding-right: 6%;
  padding-top: 42.6px;
`

const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${props => props.color ?? "#45505A"}
`

const tabPages: TabsProps['items'] = [
    {
        key: '0',
        label: `Отклики`,
    },
    {
        key: '1',
        label: `Приглашения`,
    }
];

const columnsDefault: ColumnsType = [
    {
        title: "Вакансия",
        key: "vacancy",
        width: "47.1%",
        render: (_, { vacancy }) =>
            <div>
                <Link to={'/vacancy/' + vacancy.id}>{vacancy.name}</Link>
                <Text>{vacancy.companyName}</Text>
            </div>
    },
    {
        title: "Статус",
        key: "statusText",
        width: "23%",
        dataIndex: "statusText",
        render: (statusText) => {
            switch (statusText) {
                case "Приглашение":
                    return <Text color="#29A340">{statusText}</Text>
                case "Отказ":
                    return <Text color="#F34921">{statusText}</Text>
                case "Просмотрено":
                case "Не просмотрено":
                default:
                    return <Text>{statusText}</Text>
            }
        }
    },
    {
        title: "Активность",
        key: "vacancy",
        width: "16.6%",
        dataIndex: "vacancy",
        render: (vacancy) => <Text> {vacancy.status} </Text>
    },
    {
        title: "Дата",
        key: "dateReaction",
        width: "13.3%",
        dataIndex: "dateReaction",
    },
]

const optionsReplies = [
    { value: 8, label: 'Все' },
    { value: 1, label: 'Приглашения' },
    { value: 3, label: 'Просмотрено' },
    { value: 4, label: 'Не просмотрено' },
    { value: 2, label: 'Отказ' }
]

const optionsInvitations = [
    { value: 5, label: `Вас пригласили` },
    { value: 6, label: `Вы приняли` },
    { value: 7, label: `Вы отклонили` }
]

let filterOption: number;
let selectedPage: number;
let repliesPageSize = 5;

export const StudentReplies = () => {
    const { getReactionsByProfile: getReactionByProfile, updateReactionStatusByProfile } = usePortalService();

    const columnsWithButtons: ColumnsType = [
        {
            title: "Вакансия",
            key: "vacancy",
            width: "32%",
            render: (_, { vacancy }) =>
                <div>
                    <Link to={'/vacancy/' + vacancy.id}>{vacancy.name}</Link>
                    <Text>{vacancy.companyName}</Text>
                </div>
        },
        {
            title: "Активность",
            key: "vacancy",
            width: "16.6%",
            dataIndex: "vacancy",
            render: (vacancy) => <Text> {vacancy.status} </Text>

        },
        {
            title: "Дата",
            key: "dateReaction",
            width: "13.3%",
            dataIndex: "dateReaction",
        },

        {
            title: "Ответ",
            key: "status",
            width: "33%",
            align: "right",
            dataIndex: "status",
            render: (status, record) => {
                switch (status) {
                    case 4:
                        return <>
                            <Button type="primary"
                                style={{ height: '32px', padding: '5px 8px', marginRight: '8px', marginBottom: '8px' }}
                                onClick={() => replyToInvitation(record.id, ReactionStatus.StudentAccepted)}>
                                Принять
                            </Button>
                            <Button danger
                                style={{ height: '32px', padding: '5px 8px' }}
                                onClick={() => replyToInvitation(record.id, ReactionStatus.StudentRejected)}>
                                Отклонить
                            </Button>
                        </>
                    case 5:
                        return <Text color="#29A340"> Вы приняли </Text>
                    case 6:
                        return <Text color="#F34921"> Вы отклонили </Text>
                    default:
                        return <Text> {status} test </Text>
                }
            }
        },
    ]

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(repliesPageSize);
    const [totalCount, setTotalCount] = useState(0);

    const [columns, setColumns] = useState(columnsDefault);
    const [selectOptions, setSelectOptions] = useState(optionsReplies);
    const [selectedStatus, setSelectedStatus] = useState(8);

    const [replies, setReplies] = useState<Reaction[]>([]);

    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        filterOption = 8
        selectedPage = 1
        getReactionByProfile({
            offset: 0,
            limit: repliesPageSize,
            sortBy: "string",
            sortOrder: 0,
            filter: {
                filterOption
            }
        }).then(result => {
            if (result.success) {
                setReplies(result.reactions.items)
                setTotalCount(result.reactions.totalCount)
            }
        }).catch(error => {
            setHasError(true);
            console.log(error)
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    const findReplies = async () => {
        setIsLoading(true);
        const offset = (selectedPage - 1) * repliesPageSize;
        await getReactionByProfile({
            offset,
            limit: repliesPageSize,
            sortBy: "string",
            sortOrder: 0,
            filter: {
                filterOption
            }
        }).then(result => {
            if (offset > result.reactions.totalCount && result.reactions.totalCount != 0) {
                selectedPage = Math.ceil(result.reactions.totalCount / repliesPageSize);
                setPage(selectedPage)
                findReplies();
            } else {
                setReplies(result.reactions.items)
                setTotalCount(result.reactions.totalCount)
            }
        }).catch(error => {
            setHasError(true);
            console.log(error)
        }).finally(() => {
            setIsLoading(false);
        });
        setIsLoading(false);
    }

    const tabHandler = (key: string) => {
        if (key === "1") {
            setColumns(columnsWithButtons)
            setSelectOptions(optionsInvitations)
            setSelectedStatus(5)
            filterOption = 5
        } else {
            setColumns(columnsDefault)
            setSelectOptions(optionsReplies)
            setSelectedStatus(8)
            filterOption = 8
        }
        setPage(1)
        selectedPage = 1;
        findReplies();
    };

    const selectHandler = (e: number) => {
        filterOption = e
        setSelectedStatus(filterOption);
        findReplies();
    }

    const pageHandler: PaginationProps['onChange'] = (pageNumber) => {
        setPage(pageNumber)
        selectedPage = pageNumber;
        findReplies();
    };

    const pageSizeHandler: PaginationProps['onShowSizeChange'] = (current, pageSize) => {
        repliesPageSize = pageSize;
        setPageSize(pageSize)
    };

    const replyToInvitation = async (reactionId: number, reactionStatus: number) => {
        const result = await updateReactionStatusByProfile({
            reactionId,
            reactionStatus
        });
        if (result.success) {
            setReplies(prevState =>
                prevState.map(item =>
                    item.id === reactionId
                        ? { ...item, status: reactionStatus - 1 }
                        : item
                )
            )
        }
    }

    return (
        <>
            <StudentsNavbar />
            <Container>
                <h1 style={{ marginBottom: "16px" }}>Все отклики и приглашения</h1>
                <Tabs items={tabPages} onChange={tabHandler} />
                <Select
                    style={{ marginBottom: '24px', maxWidth: '550px', minWidth: '200px' }}
                    value={selectedStatus}
                    onChange={selectHandler}
                    options={selectOptions}>
                </Select>
                {/* <Form.Select
              style={{marginBottom:'24px', maxWidth: '550px', minWidth: '200px'}}>
                <option> Все отклики </option>
                </Form.Select> */}
                {(totalCount !== 0 && !isLoading && !hasError) ?
                    <Table
                        columns={columns}
                        dataSource={replies}
                        pagination={false}
                        style={{ marginBottom: '32px' }}
                    /> :
                    (Array.from({ length: 5 }).map((_, index) =>
                        <LoaderWithTimer key={index} isLoading={isLoading} skeletonStyle="replies" />
                    ))
                }
                {(totalCount === 0 && !isLoading && !hasError) && <p style={{ paddingLeft: '20%' }}> Нет откликов </p>}
                {(totalCount > 5 && !isLoading && !hasError) &&
                    <div className="d-flex justify-content-center">
                        <Pagination
                            current={page}
                            total={totalCount}
                            onChange={pageHandler}
                            showSizeChanger
                            pageSize={pageSize}
                            onShowSizeChange={pageSizeHandler}
                            pageSizeOptions={[100, 50, 30, 20, 15, 9, 5]}
                        />
                    </div>
                }
                {hasError && <p>Произошла ошибка при загрузке. Пожалуйста, попробуйте обновить страницу.</p>}
            </Container>
        </>
    )
}